/*
 * Copyright 2026 Sophos Limited. All rights reserved.
 *
 * 'Sophos' and 'Sophos Anti-Virus' are registered trademarks of Sophos Limited and Sophos Group. All other product
 * and company names mentioned are trademarks or registered trademarks of their respective owners.
 */
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { type ReactElement } from "react";
import { type FilterStatsResult } from "../../services/dailyChecksApi";

type FilterStatsTableProps = {
  /** Filter rate limiting data */
  data: FilterStatsResult;
};

/** Renders the top organisations hitting SOC.OS filter rate limits */
export function FilterStatsTable({ data }: FilterStatsTableProps): ReactElement {
  return (
    <TableContainer>
      <Table size="small" aria-label="filter-stats">
        <TableHead>
          <TableRow>
            <TableCell>Organisation ID</TableCell>
            <TableCell>Region</TableCell>
            <TableCell align="right">Event Count</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.topOrgs.map((org, i) => (
            <TableRow key={i} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
              <TableCell>{org.organisationId}</TableCell>
              <TableCell>{org.region}</TableCell>
              <TableCell align="right">{org.eventCount.toLocaleString()}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
